module.exports = {
  apiPrefix: 'https://www.corriere.it',
  build: {
    entryPublicPath: 'https://components2.corriereobjects.it'
  },
  externals: []
};



// WEBPACK FOOTER //
// ./config/config.prod.js